import { CommonInputProps, InputLabel } from './common';
import { useRef } from 'react';
import { Horizontal } from 'packages/radiant-react/layout';
import styles from './styles.module.scss';
import { ColorPicker, PICKER_VIEW } from 'packages/radiant-react/colorpicker';

export const ColorInput = ({ value, onChange, name, info }: CommonInputProps) => {
  const spanRef = useRef<HTMLSpanElement>(null);

  return (
    <Horizontal className={styles.colorInputWrapper}>
      <InputLabel name={name} info={info} />
      <Horizontal className={styles.colorPickerActions}>
        <Horizontal ref={spanRef} className={styles.colorPickerWrapper}>
          <ColorPicker
            viewType={PICKER_VIEW.LIMITED}
            defaultValue={value || 'initial'}
            onChange={(color: any) => onChange(color)}
            className={styles.colorPicker}
          />
        </Horizontal>
      </Horizontal>
    </Horizontal>
  );
};
